import {Athlete} from "./athlete";

export class Parent {
    id?: string;
    firstName: string = '';
    lastName: string = '';
    address?: string;
    city?: string;
    bornCity?: string;
    bornDate?: string;
    image?: string;
    userId: string = '';
    zip?: string;
    fiscalCode?: string;
    athlete?: Athlete = new Athlete()

    constructor(raw?: Parent) {
        if (raw) {
            this.id = raw.id;
            this.firstName = raw.firstName;
            this.lastName = raw.lastName;
            this.address = raw.address;
            this.city = raw.city;
            this.bornCity = raw.bornCity;
            this.bornDate = raw.bornDate;
            this.image = raw.image;
            this.userId = raw.userId;
            this.zip = raw.zip;
            this.fiscalCode = raw.fiscalCode;
            if (raw.athlete) this.athlete = raw.athlete;
        }
    }
}
